{
  "language": {
    "name": "தமிழ்"
  },
  "nav": {
    "about": "பற்றி",
    "expertise": "நிபுணத்துவம்",
    "certifications": "சான்றிதழ்கள்",
    "connect": "தொடர்பு"
  },
  "hero": {
    "badge": "சிங்கப்பூரில் சுகாதார பாத்திரங்களுக்கு கிடைக்கிறது",
    "title": "நார்டிக் சிறப்பை தென்கிழக்கு ஆசிய இதயத்துடன் இணைத்தல்",
    "stats": {
      "certifications": "சரிபார்க்கப்பட்ட சான்றிதழ்கள்",
      "languages": "பேசப்படும் மொழிகள்",
      "geriatric": "முதியோர் பராமரிப்பு கவனம்"
    },
    "cta": {
      "download": "CV பதிவிறக்கம்",
      "explore": "எனது இரண்டு உலகங்களை ஆராயுங்கள்"
    }
  },
  "worlds": {
    "title": "எனது இரண்டு உலகங்கள்",
    "finland": {
      "title": "பின்லாந்து: நான் பயிற்சி பெற்ற இடம்",
      "points": [
        "கடுமையான ஆதார அடிப்படையிலான சுகாதார கல்வி",
        "டுவோடெசிமிலிருந்து 20+ சிறப்பு சான்றிதழ்கள்",
        "நோயாளி பாதுகாப்பு மற்றும் தர மேம்பாடு கவனம்",
        "பின்னிஷ் சுகாதார அமைப்பில் மேம்பட்ட மருத்துவ திறன்கள்"
      ]
    },
    "asia": {
      "title": "தென்கிழக்கு ஆசியா: நான் சேர்ந்த இடம்",
      "points": [
        "தாய் கலாச்சார வேர்கள் மற்றும் குடும்ப மதிப்புகள்",
        "ஆசிய சுகாதார எதிர்பார்ப்புகளின் புரிதல்",
        "பல்மொழி தொடர்பு திறன்கள்",
        "நோயாளி பராமரிப்பில் கலாச்சார உணர்திறன்"
      ]
    },
    "bridge": {
      "title": "இரு உலகங்களையும் இணைத்தல்",
      "points": {
        "evidence": {
          "title": "ஆதார அடிப்படையிலான நடைமுறை",
          "desc": "பின்னிஷ் பயிற்சி ஆசிய அரவணைப்பை சந்திக்கிறது"
        },
        "cultural": {
          "title": "கலாச்சார புத்திசாலித்தனம்",
          "desc": "பல்வேறு நோயாளி தேவைகளை வழிநடத்துதல்"
        },
        "tech": {
          "title": "தொழில்நுட்ப சிறப்பு",
          "desc": "நவீன சுகாதார அமைப்புகள்"
        },
        "family": {
          "title": "குடும்ப-மையப்படுத்தப்பட்ட பராமரிப்பு",
          "desc": "குணப்படுத்துவதற்கான முழுமையான அணுகுமுறை"
        }
      }
    }
  },
  "patient": {
    "title": "நோயாளி-மையப்படுத்தப்பட்ட தொடர்பு",
    "subtitle": "பல்வேறு நோயாளி தேவைகளை பூர்த்தி செய்ய நான் எனது தொடர்பு பாணியை எவ்வாறு மாற்றியமைக்கிறேன்",
    "conversations": {
      "medication": {
        "patient": "இவ்வளவு மருந்துகளை எடுத்துக்கொள்வது குறித்து நான் கவலைப்படுகிறேன். என் மகள் அது மிக அதிகம் என்று கூறுகிறார்.",
        "nurse": "உங்கள் கவலையை நான் புரிந்துகொள்கிறேன். ஒவ்வொரு மருந்தையும் ஏன் உங்கள் மீட்புக்கு முக்கியம் என்பதை விளக்குகிறேன். உங்கள் மகள் மற்றும் மருத்துவருடன் இதை விவாதிக்கலாம், எல்லோரும் சிகிச்சை திட்டத்துடன் வசதியாக இருப்பதை உறுதிசெய்யலாம்."
      },
      "pain": {
        "patient": "வலி மோசமாகிக்கொண்டிருக்கிறது, ஆனால் நான் யாரையும் தொந்தரவு செய்ய விரும்பவில்லை.",
        "nurse": "உங்கள் வசதி எங்களுக்கு மிகவும் முக்கியம். உங்கள் வலியைப் பற்றி எங்களிடம் சொல்ல தயங்காதீர்கள். உங்கள் வலி நிலையை மதிப்பிடுகிறேன், அதை திறம்பட நிர்வகிக்க நாங்கள் ஒன்றாக வேலை செய்வோம். உங்கள் நல்வாழ்வு எங்கள் முன்னுரிமை."
      },
      "family": {
        "patient": "என் குடும்பம் என்னுடன் தங்க முடியுமா? அவர்கள் இங்கே இருக்கும்போது நான் நன்றாக உணர்கிறேன்.",
        "nurse": "நிச்சயமாக. குடும்ப ஆதரவு குணப்படுத்துவதற்கான முக்கிய பகுதியாகும். எல்லோருக்கும் வேலை செய்யும் சந்திப்பு நேரங்களை ஏற்பாடு செய்வோம், அதே நேரத்தில் நீங்கள் போதுமான ஓய்வு பெறுவதை உறுதிசெய்வோம். உங்கள் பராமரிப்பில் உங்கள் குடும்பத்தின் ஈடுபாட்டை நாங்கள் மதிக்கிறோம்."
      }
    }
  },
  "cv": {
    "title": "வாழ்க்கை வரலாறு",
    "sections": {
      "personalInfo": "தனிப்பட்ட தகவல்",
      "summary": "தொழில்முறை சுருக்கம்",
      "licenses": "செவிலியர் பதிவு & தகுதிகள்",
      "education": "கல்வி",
      "experience": "தொழில்முறை அனுபவம்",
      "certifications": "தொடர்ச்சியான தொழில்முறை மேம்பாடு",
      "skills": "மருத்துவ திறன்கள்",
      "languages": "மொழிகள்"
    },
    "personalInfo": {
      "fullName": "முழு பெயர்",
      "dateOfBirth": "பிறந்த தேதி",
      "nationality": "குடியுரிமை",
      "contact": "தொடர்பு",
      "email": "மின்னஞ்சல்",
      "location": "தற்போதைய இடம்"
    },
    "summary": "பின்னிஷ் சுகாதார பயிற்சி மற்றும் செயலில் உள்ள செவிலியர் உரிமங்களுடன் அர்ப்பணிப்புள்ள பதிவு செய்யப்பட்ட செவிலியர். அறுவை சிகிச்சை, மனநல, முதியோர் பராமரிப்பு மற்றும் அவசர பராமரிப்பில் நிபுணத்துவம். ஆதார அடிப்படையிலான நடைமுறை, நோயாளி பாதுகாப்பு மற்றும் பல்துறை ஒத்துழைப்பில் நிரூபிக்கப்பட்ட திறன். சிங்கப்பூரின் சுகாதார அமைப்புக்கு மருத்துவ சிறப்பு மற்றும் கலாச்சார தகவமைப்பு திறனை பங்களிக்க விரும்புகிறார்.",
    "licenses": {
      "nursing": {
        "title": "பின்னிஷ் செவிலியர் உரிமம்",
        "details": "உரிமம் பெற்ற பதிவு செய்யப்பட்ட செவிலியர் (Sairaanhoitaja) | பதிவு எண்: 10009985648 | வழங்கியவர்: Valvira | நிலை: செயலில்"
      },
      "medication": {
        "title": "பின்னிஷ் மருந்து உரிமம்",
        "details": "உரிம வகை: Love (Lääkkeenmääräämis Lupa hoitajille) | நிலை: செல்லுபடியாகும்"
      }
    },
    "education": {
      "degree": "சுகாதார பராமரிப்பு இளங்கலை (செவிலியர் அறிவியல்)",
      "institution": "LAB பயன்பாட்டு அறிவியல் பல்கலைக்கழகம், லாஹ்டி, பின்லாந்து",
      "year": "பட்டம் பெற்ற ஆண்டு"
    },
    "experience": {
      "responsibilities": "முக்கிய பொறுப்புகள்",
      "achievements": "முக்கிய சாதனைகள்",
      "0": {
        "title": "செவிலியர் மாணவர் - கடுமையான பராமரிப்பு பிரிவு",
        "organization": "Päijät-Häme மத்திய மருத்துவமனை",
        "location": "லாஹ்டி, பின்லாந்து",
        "period": "பிப்ரவரி 2025 - ஏப்ரல் 2025",
        "responsibilities": [
          "கடுமையான பராமரிப்பு அமைப்புகளில் விரிவான நோயாளி பராமரிப்பு வழங்கியது, உயிர்நிலை அறிகுறிகள் கண்காணிப்பு, மருந்து நிர்வாகம் மற்றும் மின்னணு சுகாதார பதிவுகளில் (LifeCare) ஆவணப்படுத்தல் உட்பட",
          "IV கேனுலேஷன், ECG பதிவுகள் மற்றும் பல்வேறு நோயாளி பராமரிப்பு தலையீடுகள் போன்ற மருத்துவ செயல்முறைகளை செய்தது",
          "மருத்துவர்கள், உடற்பயிற்சி சிகிச்சையாளர்கள் மற்றும் மருந்தாளர்கள் உள்ளிட்ட பல்துறை குழுக்களுடன் ஒத்துழைத்தது",
          "நோயாளி நிலைமைகளை மதிப்பீடு செய்தது, உயிர்நிலை அறிகுறிகளில் மாற்றங்களுக்கு பதிலளித்தது மற்றும் கவலைகளை சரியான முறையில் அதிகரித்தது"
        ]
      },
      "1": {
        "title": "செவிலியர் மாணவர் - அறுவை சிகிச்சை அரங்கம்",
        "organization": "Etelä-Karjala மத்திய மருத்துவமனை",
        "location": "லாப்பீன்ரான்டா, பின்லாந்து",
        "period": "ஜனவரி 2025 - பிப்ரவரி 2025",
        "responsibilities": [
          "அனைத்து மூன்று பாத்திரங்களிலும் அறுவை சிகிச்சை காலகட்ட செவிலியர் பராமரிப்பில் விரிவான அனுபவம் பெற்றது: மயக்க மருந்து செவிலியர், ஸ்க்ரப் செவிலியர் மற்றும் சுழற்சி செவிலியர்",
          "கடுமையான அசெப்டிக் நுட்பம் மற்றும் மலட்டு புல நெறிமுறைகளை பராமரிக்கும் போது அறுவை சிகிச்சை செயல்முறைகளில் உதவியது",
          "மேம்பட்ட கண்காணிப்பு உபகரணங்களைப் பயன்படுத்தி நோயாளிகளின் உயிர்நிலை அறிகுறிகள் மற்றும் மயக்க மருந்து பதில்களை கண்காணித்தது"
        ]
      },
      "2": {
        "title": "பதிவு செய்யப்பட்ட செவிலியர் - அறுவை சிகிச்சை வார்டு",
        "organization": "Päijät-Häme மத்திய மருத்துவமனை, வார்டு R5",
        "location": "லாஹ்டி, பின்லாந்து",
        "period": "டிசம்பர் 2024 - பிப்ரவரி 2025",
        "responsibilities": [
          "30 படுக்கை கடுமையான பராமரிப்பு வார்டில் அறுவை சிகிச்சை நோயாளிகளுக்கு விரிவான அறுவை சிகிச்சைக்கு முன் மற்றும் பின் செவிலியர் பராமரிப்பு வழங்கியது",
          "மருத்துவர் உத்தரவுகள் மற்றும் செவிலியர் நெறிமுறைகளின்படி மருந்துகள், IV சிகிச்சை மற்றும் வலி மேலாண்மை நிர்வகித்தது",
          "நோயாளி உயிர்நிலை அறிகுறிகள், காயம் குணப்படுத்துதல் மற்றும் அறுவை சிகிச்சைக்கு பிந்தைய மீட்பு கண்காணித்தது"
        ],
        "achievements": [
          "சிக்கலான காயம் பராமரிப்பு தேவைப்படும் உயர்-கடுமையான அறுவை சிகிச்சைக்கு பிந்தைய நோயாளிகளுக்கு பராமரிப்பை வெற்றிகரமாக நிர்வகித்தது",
          "கவனமான சரிபார்ப்பு மற்றும் ஆவணப்படுத்தல் மூலம் 100% மருந்து நிர்வாக துல்லியத்தை பராமரித்தது"
        ]
      }
    },
    "certifications": {
      "0": {
        "category": "மனநல & மன ஆரோக்கியம்",
        "items": [
          "கவலை மற்றும் தூக்கமின்மை இளைஞர்கள்: இளம் பருவ மனநல கண்ணோட்டங்கள் (55 நிமிடங்கள்) - நவம்பர் 2024",
          "ஊக்க நேர்காணல் (60 நிமிடங்கள்) - டிசம்பர் 2022"
        ]
      },
      "1": {
        "category": "முதியோர் & வயதானவர் பராமரிப்பு",
        "items": [
          "முதியோர் பலவீனம் அடையாளம் (30 நிமிடங்கள்) - அக்டோபர் 2024",
          "வயதானவர் மருந்து மேலாண்மை (60 நிமிடங்கள்) - செப்டம்பர் 2024",
          "வயதானவர்களில் பல மருந்துகள் (40 நிமிடங்கள்) - செப்டம்பர் 2024",
          "விழுதல் தடுப்பு (60 நிமிடங்கள்) - செப்டம்பர் 2024"
        ]
      },
      "2": {
        "category": "கடுமையான & அவசர பராமரிப்பு",
        "items": [
          "நரம்பியல் நோயாளி அவசர மதிப்பீடு (60 நிமிடங்கள்) - நவம்பர் 2023",
          "ABCDE கொள்கைகளைப் பயன்படுத்தி உயிர் செயல்பாடுகளின் முறையான மதிப்பீடு (30 நிமிடங்கள்) - அக்டோபர் 2023",
          "மத்திய சிரை வடிகுழாய் (CVK) செருகல் மற்றும் பயன்பாடு (70 நிமிடங்கள்) - நவம்பர் 2023"
        ]
      }
    },
    "skills": {
      "clinical": {
        "title": "நோயாளி பராமரிப்பு திறன்கள்",
        "items": [
          "விரிவான நோயாளி மதிப்பீடு மற்றும் உயிர்நிலை அறிகுறிகள் கண்காணிப்பு",
          "மேம்பட்ட காயம் பராமரிப்பு மற்றும் கட்டு மாற்றங்கள்",
          "மருந்து நிர்வாகம் (வாய்வழி, IV, IM, SC)",
          "IV கேனுலேஷன், வடிகுழாய்மயமாக்கல் மற்றும் NG குழாய் மேலாண்மை",
          "வலி மதிப்பீடு மற்றும் மேலாண்மை",
          "அறுவை சிகிச்சைக்கு முன் மற்றும் பின் நோயாளி பராமரிப்பு"
        ]
      },
      "technical": {
        "title": "தொழில்நுட்ப & மருத்துவ அமைப்புகள்",
        "items": [
          "LifeCare மின்னணு சுகாதார பதிவு (EHR) அமைப்பு",
          "மருத்துவ உபகரண செயல்பாடு (உயிர்நிலை அறிகுறிகள் கண்காணிப்பு, உட்செலுத்தும் பம்புகள், ஆக்ஸிஜன் விநியோக அமைப்புகள்)",
          "தொற்று கட்டுப்பாடு நெறிமுறைகள் மற்றும் மலட்டு நுட்பங்கள்",
          "அவசர பதில் நெறிமுறைகள் மற்றும் அடிப்படை வாழ்க்கை ஆதரவு"
        ]
      },
      "soft": {
        "title": "மென் திறன்கள் & தொழில்முறை பண்புகள்",
        "items": [
          "சிறந்த தொடர்பு மற்றும் செயலில் கேட்கும் திறன்கள்",
          "வலுவான பச்சாதாபம் மற்றும் நோயாளி-மையப்படுத்தப்பட்ட பராமரிப்பு",
          "பல்துறை அமைப்புகளில் பயனுள்ள குழு ஒத்துழைப்பு",
          "உயர் அழுத்த சூழல்களில் நேர மேலாண்மை",
          "பல்வேறு நோயாளி மக்கள்தொகையுடன் கலாச்சார உணர்திறன்"
        ]
      }
    },
    "languages": {
      "thai": "தாய்",
      "finnish": "பின்னிஷ்",
      "english": "ஆங்கிலம்"
    },
    "languageProficiency": {
      "native": "தாய்மொழி",
      "fluent": "சரளமான",
      "professional_b2": "தொழில்முறை (B2)"
    },
    "generated": "உருவாக்கப்பட்டது"
  },
  "footer": {
    "credentials": "பதிவு செய்யப்பட்ட செவிலியர், BSc (செவிலியர்)",
    "privacy": "தனியுரிமை கொள்கை",
    "terms": "பயன்பாட்டு விதிமுறைகள்",
    "copyright": "© {{year}} Mona. அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை."
  }
}